import React from 'react';
import styled from 'styled-components';

const BattlesEmpty = ({ battlesAssets }) => {
  return <Background background={battlesAssets.BATTLES_NO_BATTLES} />;
};

export default BattlesEmpty;

const Background = styled.div`
  flex-direction: column;
  width: 100vw;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-image: url(${({ background }) => background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  position: relative;
  overflow: hidden;
`;

